export { default } from './PreferenceIntroStep';
